import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Page not found · Assagart";
    // Hint to crawlers
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div
      data-testid="not-found-page"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(ellipse at top, #1A1A1A 0%, #0A0A0A 60%)",
        color: "#F5F5F5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        fontFamily: "'Manrope', system-ui, sans-serif",
      }}
    >
      <div style={{ maxWidth: 640, width: "100%", textAlign: "left" }}>
        <div
          style={{
            color: "#D4AF37",
            fontSize: 12,
            letterSpacing: "0.3em",
            textTransform: "uppercase",
            marginBottom: "1.25rem",
          }}
        >
          Error · 404
        </div>
        <h1
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "clamp(2.5rem, 6vw, 4.5rem)",
            lineHeight: 1.05,
            margin: 0,
            marginBottom: "1.25rem",
          }}
        >
          This page isn't in the vault.
        </h1>
        <p
          style={{
            color: "#A3A3A3",
            fontSize: "1.05rem",
            lineHeight: 1.7,
            marginBottom: "2rem",
            maxWidth: 520,
          }}
        >
          The page you tried to reach{" "}
          <span style={{ color: "#F5F5F5" }}>
            {location.pathname}
          </span>{" "}
          doesn't exist or has been moved. Let's get you back to safer ground.
        </p>
        <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
          <Link
            to="/"
            data-testid="not-found-home-link"
            style={{
              background: "#D4AF37",
              color: "#0A0A0A",
              padding: "0.85rem 1.75rem",
              borderRadius: 999,
              fontWeight: 600,
              textDecoration: "none",
              fontSize: 14,
              letterSpacing: "0.02em",
            }}
          >
            Back to home
          </Link>
          <Link
            to="/dashboard"
            data-testid="not-found-dashboard-link"
            style={{
              background: "transparent",
              color: "#F5F5F5",
              padding: "0.85rem 1.75rem",
              borderRadius: 999,
              fontWeight: 500,
              textDecoration: "none",
              fontSize: 14,
              border: "1px solid #262626",
            }}
          >
            Open dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
